import i18n from "../../i18n";
import React from "react";
import { Anchor, Table, Text } from "@mantine/core";
import moment from "moment";

const formatUploadedAt = (value) => {
  if (!value) return "—";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD HH:mm") : "—";
};

const McaStepFileList = ({ files = [], showMeta = false }) => {
  if (!files.length) return null;

  return (
    <Table fontSize="sm" verticalSpacing="xs">
      <thead>
        <tr>
          <th>{i18n.t("Step")}</th>
          <th>{i18n.t("Field")}</th>
          <th>{i18n.t("File")}</th>
          {showMeta && (
            <>
              <th>{i18n.t("Uploaded by")}</th>
              <th>{i18n.t("Uploaded at")}</th>
              <th>{i18n.t("Entity file")}</th>
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {files.map((file, idx) => (
          <tr key={`${file.stepIndex}-${file.fileName}-${idx}`}>
            <td>{file.stepName}</td>
            <td>{file.fieldLabel}</td>
            <td>
              {file.href ? (
                <Anchor href={file.href} target="_blank" rel="noreferrer" size="sm">
                  {file.fileName}
                </Anchor>
              ) : (
                <Text size="sm">{file.fileName}</Text>
              )}
            </td>
            {showMeta && (
              <>
                <td>{file.uploadedBy || "—"}</td>
                <td>{formatUploadedAt(file.uploadedAt)}</td>
                <td>{file.entityFileName}</td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default McaStepFileList;
